module.exports = __webpack_public_path__ + "media/images/common/ask_btn-5c237cdb187b7aabdb86a29d3c127e82.gif";